import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home({ multiDatabase = true }) {
  return (
    <div className="home-page">
      <div className="home-container">
        <h1>Welcome to StowIt</h1>
        <p className="subtitle">Keep track of your stored items and where they are</p>
        
        <div className="home-grid">
          <Link to="/locations" className="feature-card">
            <div className="card-icon">📍</div>
            <h3>Storage Locations</h3>
            <p>Create and manage storage locations for your items</p>
          </Link>

          <Link to="/items" className="feature-card">
            <div className="card-icon">📦</div>
            <h3>Items</h3>
            <p>Add and track items across your locations</p>
          </Link>

          <Link to="/scan" className="feature-card">
            <div className="card-icon">📱</div>
            <h3>Scan QR Code</h3>
            <p>Quickly find locations and items by scanning QR codes</p>
          </Link>

          {multiDatabase && (
            <Link to="/databases" className="feature-card">
            <div className="card-icon">💾</div>
            <h3>Manage Databases</h3>
            <p>Create and manage multiple storage databases</p>
            </Link>
          )}
        </div>

        <div className="quick-actions">
          <Link to="/locations/new" className="btn btn-primary">Create Storage Location</Link>
          <Link to="/items/new" className="btn btn-secondary">Create Item</Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
